module.exports = __webpack_public_path__ + "static/images/new-game.1ba077a.png";